<template>
  <div style="margin-top: 15px" v-if="isMounted">
    <h4 class="text-center m-lg">
      For companies, and team up to 10 users, unlimited usage, basic customization
    </h4>
    <carousel v-if="products" class="col-xs-10 col-xs-offset-1"
              :perPageCustom="[[0, 1], [800, 2], [1000, 2], [1400, 2], [2000, 2]]"
              :perPage="5" :navigationEnabled="true" :loop="true" :autoplay="true">
      <template v-for="(product, key) in products"  v-if="products.length && product && product.description">
        <slide class="" :key="key" :data-index="key" style="padding: 0 15px">
          <div class="hpanel hblue" >
            <div class="panel-heading hbuilt text-center">
              <h4 class="font-bold">
                <span v-if="$auth.user().profile.id !== 1 && $auth.user().role_name === product.role && $auth.user().plan.plan_id === product.planId" class="label label-info">Current</span>
                {{product.name}}
              </h4>
              <div class="text-center">
                <a class="btn btn-info btn-sm m-t-xs btn-block" target="_blank" href="https://www.idexlab.com/contact-us/  ">Contact us</a>
              </div>
            </div>
            <div class="panel-body ">
                <template v-if="product.search">
                  <table class="table">
                    <thead>
                    <tr>
                      <td width="60%">
                        <h5>Search</h5>
                      </td>
                      <td width="40%" class="text-center">
                      </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(key, search) in product.search" :key="search + key" style="font-size: 12px">
                      <td>
                        {{search}}
                      </td>
                      <td class="text-center">
                        {{key}}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </template>

                <template v-if="product.other">

                  <table class="table">
                    <thead>
                    <tr>
                      <td width="60%">
                      </td>
                      <td width="40%">
                      </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(key, feature) in product.other" :key="feature + key" style="font-size: 12px">
                      <td>
                        {{feature}}
                      </td>
                      <td class="text-center">
                        {{key}}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </template>
              <div class="text-center">
                <a class="btn btn-info btn-sm m-t-xs btn-block" target="_blank" href="https://www.idexlab.com/contact-us/  ">Contact us</a>
              </div>
            </div>
          </div>
        </slide>
      </template>
    </carousel>
  </div>

</template>

<style>
  .VueCarousel-dot-container {
    margin-top: 0 !important;
  }
</style>
<script>

import { Carousel, Slide } from 'vue-carousel'
import VueLadda from 'vue-ladda'

export default {
  components: {Carousel, Slide, VueLadda},
  name: 'ProductSelectionCorporate',
  data () {
    return {
      isMounted: false,
      products: [{
        name: 'Business Seeker',
        description: 'Description Business Seeker',
        search: {'Science': 'unlimited', 'Patents': 'unlimited', 'Companies': 'unlimited'},
        other: {'Workflows': 'All',
          'Projects storage': 'unlimited',
          'Open Innov. Campaign': '-',
          'Account provisioning': '-',
          'Team': '-',
          'On boarding': 'Custom training',
          'Support': 'Phone, Mail, Chat, Online Academy',
          'Customisation': 'Logo,Url, Preferred sources'},
        role: 'Seeker',
        planId: 4
      }, {
        name: 'Business Broker',
        description: 'Description Business Broker',
        search: {'Science': 'unlimited', 'Patents': 'unlimited', 'Companies': 'unlimited'},
        other: {'Workflows': 'All',
          'Projects storage': 'unlimited',
          'Open Innov. Campaign': 'unlimited',
          'Account provisioning': '-',
          'Team': '-',
          'On boarding': 'Custom training',
          'Support': 'Phone, Mail, Chat, Online Academy',
          'Customisation': 'Logo,Url, Preferred sources'},
        role: 'Broker',
        planId: 4

      }],
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      }
    }
  },
  mounted () {
    let products = Object.assign([], this.products)

    this.products = []

    setTimeout(() => {
      this.isMounted = true
      this.products = products
    }, 500)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/plan/ProductSelectionBusiness.vue